module.exports = __webpack_public_path__ + "static/icon_cerca_italia-3ee1e69b970ee10ffa46b710f4b79791.svg";